(() => {
  angular
    .module('gm.common.directives')
    .directive('gmAccordionMenu', gmAccordionMenuDirective);

  function gmAccordionMenuDirective(
    $timeout,
    $rootScope
  ) {
    'ngInject';

    const MENU_BLOCK_SELECTOR = '.mobile-header__menuBlock:first';

    return {
      restrict: 'A',
      scope: true,
      link(scope, element) {
        const menuBlock = element.find(MENU_BLOCK_SELECTOR);
        let openMenuTimeout;
        let menuHeight;

        const listenerMap = {
          onMenuClose: $rootScope.$on('gm:mobile-nav:close', () => {
            scope.closeMenu();
          })
        };

        scope.isMenuOpen = false;

        scope.toggleMenu = () => {
          switch (scope.isMenuOpen) {
            case true:
              scope.closeMenu();
              break;

            default:
              scope.openMenu();
          }
        };

        scope.openMenu = () => {
          scope.isMenuOpen = true;

          if (menuHeight) {
            menuBlock.css('max-height', menuHeight);
          }

          openMenuTimeout = $timeout(() => {
            menuBlock.css('transition', 'none'); // safari fix part 1
            menuBlock.css('maxHeight', 'none');
            openMenuTimeout = null;

            $timeout(() => {
              menuBlock.css('transition', ''); // safari fix part 2
            }, 10);
          }, 1000); // hardcoded open menu animation time
        };

        scope.closeMenu = () => {
          if (openMenuTimeout) {
            $timeout.cancel(openMenuTimeout);
            openMenuTimeout = null;
          }

          menuHeight = menuBlock.outerHeight();
          menuBlock.css('transition', 'none'); // safari fix part 3
          menuBlock.css('max-height', menuHeight);
          menuBlock.height();
          menuBlock.css('transition', ''); // safari fix part 4

          menuBlock.css('max-height', 0);
          scope.isMenuOpen = false;
        };

        scope.$on('$destroy', () => {
          Object.keys(listenerMap).forEach((key) => {
            listenerMap[key]();
          });
        });
      }
    };
  }
})();
